import { Routes, Route } from "react-router-dom";
import UserAuswahl from "./UserAuswahl";
import ElectronicIllnessAttestation from "../ElectronicIllnessAttestation/ElectronicIllnessAttestation";
import ElectronicIllnessAttestationHistory from "../ElectronicIllnessAttestationHistory";

function MitarbeiterAU(props) {
  const { client, accessToken, updateTitle, location } = props;

  return (
    <Routes>
      <Route
        path="/SENDAU/HISTORIE*"
        element={<ElectronicIllnessAttestationHistory updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} />}
      />
      <Route path="/SENDAU/*" element={<ElectronicIllnessAttestation updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} />} />
      <Route path="/" element={<UserAuswahl client={client} accessToken={accessToken} updateTitle={updateTitle} location={location} />} />
    </Routes>
  );
}

export default MitarbeiterAU;
